import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import SalesStaticsEmpTable from '../../components/salesresults_statics/SalesStaticsEmpTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const SalesresultsStaticsEmp = ({
  selectedYear,
  strMonth,
  strDay,
  endMonth,
  endDay,
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  // --- 상세 내역을 위한 상태 추가 ---
  const [detailData, setDetailData] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);

  // 본문 데이터 로드 (기존 로직 유지)
  const onLoadData = useCallback(async () => {
    setLoading(true);
    const apiParams = {
      startDt: `${selectedYear}-${strMonth}-${strDay}`,
      endDt: `${selectedYear}-${endMonth}-${endDay}`,
      target: 'one'
    };

    try {
      const res = await staticsApi.getSalesStaticsByNew(
        selectPrjTyp,
        apiParams,
      );
      if (res.data && res.data.list) {
        
        setData(res.data.list);
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [selectedYear, strMonth, strDay, endMonth, endDay, selectPrjTyp, enqueueSnackbar]);

  const handleCellClick = async (cellData, field, type) => {
    setDetailLoading(true);
    
    const baseParams = {
      startDt: `${selectedYear}-${strMonth}-${strDay}`,
      endDt: `${selectedYear}-${endMonth}-${endDay}`,
      empId: cellData.id,
    };

    try {
      let res;
      
      if (type.id === 'collaborationBenefits' || type.id === 'collaborationCost' ) {
        res = await staticsApi.getSalesStaticCollaborationDetail( 
          selectPrjTyp,
          { ...baseParams, partnerId: cellData.id, collaboTyp: type.id}
        );
      } 
      else {
        res = await staticsApi.getSalesStaticsByDetailNew(
          selectPrjTyp,
          { ...baseParams, type: type.id === 'sales' ? '매출' : '매입' }
        );
      }

      if (res.data && res.data.list) {
        const sortedData = [...res.data.list].sort((a, b) => {
          const dateA = a.reqCompDt || '9999-12-31';
          const dateB = b.reqCompDt || '9999-12-31';
          return dateA.localeCompare(dateB);
        });
        setDetailData(sortedData);
      } else {
        setDetailData([]);
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(`상세 내역 로드 실패: ${message}`, { variant: 'error' });
      setDetailData([]);
    } finally {
      setDetailLoading(false);
    }
  };



  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData, onLoadData]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <SalesStaticsEmpTable
      data={data}
      loading={loading}
      tableRef={tableRef}
      selectPrjTyp={selectPrjTyp}
      strMonth={strMonth}
      endMonth={endMonth}
      // --- 상세 내역 관련 Props 추가 ---
      onCellClick={handleCellClick}
      detailData={detailData}
      detailLoading={detailLoading}
    />
  );
};

export default SalesresultsStaticsEmp;
